import React, { useCallback, useContext, useEffect, useState } from 'react';
import OrderCard from './OrderCard';
import { Box, Button, FlexBox, Icon, Spinner } from '@vp/swan';
import { IOrderData } from '../../../interfaces/order-tracking-flow-interfaces';
import { ChatbotContext } from '../../../contexts/ChatbotContext';
import { useCBFetchOrders } from '../../../hooks/chatbot/useCBFetchOrders';
import { CAContext } from '../../../contexts/CAContext';

export interface IOrderListProps {
  sender: 'chatbot' | 'user';
  ordersCount: number;
  orders: IOrderData[];
  onClick?: (selectedOrderId: string) => void;
}

const OrderList: React.FC<IOrderListProps> = ({
  orders,
  // onClick,
  ordersCount,
  sender,
}) => {
  const {
    chatState: { scrollToBottom },
  } = useContext(CAContext);
  const { data, loading, trigger } = useCBFetchOrders();
  const {
    state: { sendChatbotMessage },
  } = useContext(ChatbotContext);
  const [ordersToShow, setOrdersToShow] = useState<IOrderData[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showLoadMoreButton, setShowLoadMoreButton] = React.useState(false);

  useEffect(() => {
    if (orders) {
      setOrdersToShow(orders);
    }
  }, [orders]);

  const onOrderClick = useCallback(
    (orderId: string) => {
      const selectedOrder = ordersToShow.find((order) => order.orderId === orderId);

      if (sendChatbotMessage && selectedOrder) {
        sendChatbotMessage({
          type: 'order_select',
          messageData: selectedOrder as IOrderData,
        });
      }
    },
    [sendChatbotMessage, ordersToShow],
  );

  useEffect(() => {
    if (data) {
      setOrdersToShow((prevOrders) => [...prevOrders, ...data]);
      scrollToBottom?.();
    }
  }, [data]);

  const onLoadMore = useCallback(() => {
    trigger({ pageNumber: currentPage + 1 });
    setCurrentPage((prevPage) => prevPage + 1);
  }, [currentPage]);
  useEffect(() => {
    if (ordersToShow.length < ordersCount) {
      setShowLoadMoreButton(true);
    } else {
      setShowLoadMoreButton(false);
    }
  }, [ordersToShow, ordersCount]);
  return (
    <Box>
      {ordersToShow.map((order) => (
        <OrderCard
          key={order.orderId}
          orderDate={order.orderDate}
          orderId={order.orderId}
          orderItems={order.orderItems}
          orderNumber={order.orderNumber}
          displayPrice={order.displayPrice}
          onClick={onOrderClick}
          sender={sender}
        />
      ))}
      {showLoadMoreButton && (
        <FlexBox justifyContent="space-around" marginBottom="between-actions">
          <Button skin="tertiary" onClick={onLoadMore} iconPosition="left" disabled={loading}>
            {loading ? <Spinner size="mini" accessibleText="loading" /> : <Icon iconType="arrowDown" />}
            Load more
          </Button>
        </FlexBox>
      )}
    </Box>
  );
};

export default OrderList;
